import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { observer, inject } from "mobx-react";
import { compose } from "recompose";
import FormSectionHeader from "./../common/FormSectionHeader";
import { withExceptionDetailsHOC } from "../ProcessDelivery/ExceptionDetail";

const styles = (theme) => ({
  label: {
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize,
  },
  value: {
    color: theme.TextColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  valueHighlighted: {
    color: theme.HeaderSelectedText,
    fontWeight: 600,
  },
  valueContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 8,
  },
});

@inject("DispatchStore")
@observer
class ExceptionDetails extends React.Component {
  render() {
    const { classes, exceptionDetails, deliveryException } = this.props;
    const { ExceptionDetailsInfo } = deliveryException;
    return (
      <>
        <FormSectionHeader label="EXCEPTION DETAILS" />
        <div className={classes.valueContainer}>
          <span className={classes.label}>Exception Type</span>
          <span className={classes.value}>
            {
              this.props.DispatchStore.getExceptionDetails(
                exceptionDetails.code
              ).description
            }
          </span>
        </div>
        <ExceptionDetailsInfo
          classes={classes}
          exceptionDetails={exceptionDetails}
          packageTypeList={this.props.DispatchStore.packageCodes}
        />
      </>
    );
  }
}

export default compose(withStyles(styles))(
  withExceptionDetailsHOC(ExceptionDetails)
);
